export default __webpack_public_path__ + "static/light-node-19ec068f934f78fcee6a951e4fd431a9.png";